<epay-page-content [pagetitle]="pagetitle">
  <div class="box-panel shadow max-w max-gs">
    <div class="m--pa4">
      <h2 class="mb-5">Contact Us</h2>

      <div class="container">
        <h3><u>Non-custodial Parent</u></h3>
        <div class="mx-3">
          <h3 class="mt-3">Telephone</h3>
          <span><u>Metro Denver</u>: 303-299-9123</span> <br>
          <span><u>Nationwide</u>: 1-800-374-6558</span> <br>
          <br>
  
          <h3>Email</h3>
          <span>
            <a href="mailto:cdhs_fsrcustomerservice@state.co.us">cdhs_fsrcustomerservice@state.co.us</a>
          </span> 
          <br>
        </div>

        <hr>
  
        <h3><u>FSR Employer Services</u></h3>
        <div class="mx-3">
          <h3 class="mt-3">Telephone</h3>
          <span><u>Metro Denver</u>: 303-297-2849</span> <br>
          <span><u>Nationwide</u>: 1-800-696-1468</span> <br>
          <br>

          <h3>Email</h3>
          <span>
            <a href="mailto:cdhs_fsremployerservices@state.co.us">cdhs_fsremployerservices@state.co.us</a>
          </span> 
          <br>
        </div>

  
        <br><br>
        <div *ngIf="this.chatLive">
          <h3>Live Chat</h3>
          <span>
            <img (click)="openChat()" src="../../../../../assets/images/chaticonmid.png" alt="Chat Icon" style="cursor: pointer">
          </span>
        </div>
      </div>
      
    </div>
  </div>
</epay-page-content>
